module.exports = __webpack_public_path__ + "static/media/karta_klienta_KSK.d3e38620.png";